import React, { Component } from "react";
import { Col } from "reactstrap";
import Fade from "react-reveal/Fade";

import classnames from "classnames";

class Sidebar extends Component {
  render() {
    var classes = this.props.className;
    return (
      <Col
        xs={12}
        md={this.props.md}
        className={classnames("sidebar h-100 ", classes, {
          " h-100 ": !this.props.UnownedFund,
        })}
      >
        <div
          className={classnames(
            {
              "d-flex h-100 align-items-center sidebar-content flex-column": !this
                .props.UnownedFund,
            },
            this.props.justify,
            { "sidebar-content": this.props.UnownedFund }
          )}
        >
          {this.props.fromRight ? (
            <Fade right duration={500}>
              {this.props.children}
            </Fade>
          ) : (
            <Fade left duration={500}>
              {this.props.children}
            </Fade>
          )}
        </div>
      </Col>
    );
  }
}

export default Sidebar;
